import React, { useMemo, useState } from 'react'
import Available from './Available'
import Editor from './Editor'
import Summary from './Summary'
import ViewOnly from './ViewOnly'

function ComplianceFormState({ state, entry, canEdit, canReset, packageHashedId, dealParties, goEdit, onSaved, onCancel, onReset }) {
  switch (state) {
    case 'complete':
      return <Summary entry={entry} canEdit={canEdit} canReset={canReset} packageHashedId={packageHashedId} onReset={onReset} dealParties={dealParties} />
    case 'view_only':
      return <ViewOnly entry={entry} />
    case 'in_progress':
      return (
        <Editor
          packageHashedId={packageHashedId}
          dealParties={dealParties}
          currentEntry={entry}
          onSaved={onSaved}
          onCancel={onCancel}
        />
      )
    default:
      return null
  }
}

export default function ComplianceForm(props) {
  const { formState, canEdit, canReset, currentEntry, packageHashedId, dealParties } = props
  const [state, setState] = useState(formState)
  const [entry, setEntry] = useState(currentEntry)
  // canEdit arrives as a page-load prop, but a save can close the window it was made through
  // (the processor-working unlock is one-shot), so it has to track the save response.
  const [editable, setEditable] = useState(canEdit)

  const goEdit   = () => setState('in_progress')
  const onSaved  = (newEntry, meta) => {
    setEntry(newEntry)
    setState(meta?.state || 'complete')
    if (meta && 'canEdit' in meta) setEditable(meta.canEdit)
  }
  const onCancel = () => setState(entry ? 'complete' : 'available')
  // TODO: reset does not refresh `editable`, so it keeps the page-load canEdit. A viewer who could
  // not edit the completed form (i.e. not its submitter) is shown the available state with no edit
  // affordance until a page refresh, even though the server does now allow the refill. Fix as the
  // save path does: return the recomputed state/canEdit from the reset endpoint and apply it here.
  const onReset  = () => { setEntry(null); setState('available') }
  const isAvailable = useMemo(() => state === 'available', [state])

  return (
    <div className="ny1120b-compliance-form dome-light-shadow dome-bg-white dome-rounded-border">
      <Available packageHashedId={packageHashedId} onBegun={goEdit} isAvailable={isAvailable} state={state} canEdit={editable} onEdit={goEdit} />
      <ComplianceFormState
        state={state}
        entry={entry}
        canEdit={editable}
        canReset={canReset}
        packageHashedId={packageHashedId}
        dealParties={dealParties}
        goEdit={goEdit}
        onSaved={onSaved}
        onCancel={onCancel}
        onReset={onReset}
      />
    </div>
  )
}
